import type { Ref } from 'react';
import classNames from 'classnames';
import FJDropDown from '@src/common/components/FJDropDown/FJDropDown';
import FJIconBox from '@src/common/components/FJIconBox/FJIconBox';
import FJMoreIcon from '../../assets/more.svg?react';
import FJRenameIcon from '../../assets/rename.svg?react';
import FJDeleteIcon from '../../assets/delete.svg?react';
import FJLocalStore from '../../store/FJLocalStore';
import styles from './FJMoreDropList.module.less';
import FJUtil from '@src/util/FJUtil';

interface FJMoreDropListProps {
    fileId: string;
    onRename?: (id: string) => void;
    onDelete?: (id: string) => void;
    /** 附加在根节点，便于布局对齐 */
    forbidWheelEvent?: boolean;
    className?: string;
}

export default function FJMoreDropList({
    fileId,
    onRename,
    onDelete,
    className,
    forbidWheelEvent = false,
}: FJMoreDropListProps) {
    return (
        <div className={classNames(styles.root)}>
            <FJDropDown
                placement='rightTop'
                zIndex={20}
                triggerDisplay='flex'
                isNeedBindWheelEvent={true}
                renderTrigger={triggerProps => {
                    const { ref, style, onClick, onMouseMove } = triggerProps;
                    return (
                        <FJIconBox
                            ref={ref as Ref<HTMLButtonElement>}
                            icon={<FJMoreIcon aria-hidden />}
                            aria-label={FJLocalStore._('more-options')}
                            tooltipTitle={FJLocalStore._('more-options')}
                            className={className}
                            style={style}
                            onClick={onClick}
                            onMouseMove={onMouseMove}
                        />
                    );
                }}
                renderOverlay={overlayProps => {
                    const { hide, ref } = overlayProps;
                    return (
                        <ul
                            ref={ref as Ref<HTMLUListElement>}
                            className={styles.menu_list}
                            role='menu'
                            onWheel={forbidWheelEvent ? e => FJUtil.forbidEvent(e) : undefined}
                        >
                            <li role='none'>
                                <button
                                    type='button'
                                    className={styles.menu_item}
                                    role='menuitem'
                                    onClick={() => {
                                        hide();
                                        onRename?.(fileId);
                                    }}
                                >
                                    <FJRenameIcon aria-hidden />
                                    {FJLocalStore._('rename')}
                                </button>
                            </li>
                            <li role='none'>
                                <button
                                    type='button'
                                    className={styles.menu_item}
                                    role='menuitem'
                                    onClick={() => {
                                        hide();
                                        onDelete?.(fileId);
                                    }}
                                >
                                    <FJDeleteIcon aria-hidden />
                                    {FJLocalStore._('delete')}
                                </button>
                            </li>
                        </ul>
                    );
                }}
            />
        </div>
    );
}
